export default __webpack_public_path__ + "static/BasierCircle-SemiBold-a05b38a01da6e7bc7a5fa15d0d47e281.woff2";